// src/screens/my-bookings/params/no-bookings.screen.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const NoBookingsScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center p-12 text-center bg-white rounded-xl border border-neutral-100">
      <div className="w-24 h-24 bg-primary bg-opacity-10 rounded-full flex items-center justify-center mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      </div>
      <h2 className="text-2xl font-black text-neutral-900 mb-2">No Active Bookings</h2>
      <p className="text-neutral-500 max-w-md mb-8">
        You haven&apos;t booked any properties yet. Once you make a payment, your secured escrow transactions will appear here.
      </p>
      <button
        onClick={() => navigate("/dashboard/property-list")}
        className="bg-primary hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-lg transition-all"
      >
        Find a Ruum
      </button>
    </div>
  );
};

export default NoBookingsScreen;